export const GETUSERS = "GETUSERS"
export const GETQUESTIONS = "GETQUESTIONS"
export const LOGIN = "LOGIN"
export const LOGOUT = "LOGOUT"

export const ADD_QUESTION = "ADD_QUESTION";
export const ANSWER_QUESTION = "ANSWER_QUESTION";
export const RECEIVE_QUESTIONS = "RECEIVE_QUESTIONS";

export const ADD_QUESTION_USER ="ADD_QUESTION_USER";
export const ANSWER_QUESTION_USER ="ANSWER_QUESTION_USER";